import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken = 'pk.eyJ1IjoibW92ZWNyZWF0aXZlIiwiYSI6ImNseXpqYzB2eDI5ZWoyaXNobHBwdXZpYm0ifQ.X9E0EZ6Ls0P9vK7ns4waVg';


        

 $('.block__map-with-filter').each(function(){
	let block = $(this)
	let map
	let locations = []
	const categoryCheckboxes = block.find('.element-checkbox input')

	// Initialize map
	map = new mapboxgl.Map({
	    container: $(this).find('.js-map')[0],
	    //style: 'mapbox://styles/mapbox/outdoors-v12',
	    style: 'mapbox://styles/movecreative/clz1fnn7400jk01nv7neu09ud',
	    center: [24.422982, 57.030165],
	    zoom: 6
	});

	block.find('.js-location').each(function(){
		let location = {
			// text: $(this).data('text'),
			// url: $(this).data('url'),
			categories: $(this).data('filters-tax'),
			lat: $(this).data('lat'),
			lng: $(this).data('lng'),
			icon: $(this).data('icon'),
			html: $(this).data('text'),
		}
		location.categories.push(0)
		locations.push(location)
	})



	// Function to add markers to the map
	function addMarkers(filteredObjects) {
	    // Clear existing markers
	    const markers = document.getElementsByClassName('marker');
	    while(markers[0]) {
	        markers[0].parentNode.removeChild(markers[0]);
	    }

	    // Add new markers
	    filteredObjects.forEach(object => {
	        const el = document.createElement('div');
	        el.className = 'marker';
	        el.style.backgroundImage = `url(${object.icon})`;
	        el.style.width = '34px';
	        el.style.height = '46px';
	        el.style.backgroundSize = '100%';

	        let newMarker = new mapboxgl.Marker(el)
	           
          if (object.lng && object.lat){
          	const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(object.html);

          	newMarker.setLngLat([object.lng, object.lat]).setPopup(popup).addTo(map);
          }
	    });
	}

	// Initial load of all locations
	addMarkers(locations);

	// Function to filter locations by category
	function filterByCategory(category) {
	    if(category === 0) {
	        addMarkers(locations);
	    } else {
	        //const filteredObjects = locations.filter(object => object.categories.includes(category));

	        let filteredObjects = []
			    let selectedCategories = getSelectedCategories();

			    locations.forEach(function (marker) {
		      	let isVisible = selectedCategories.some(function (category) {
			        return marker.categories.includes(parseInt(category));
			      });

			      if (isVisible) filteredObjects.push(marker)

			    });



	        addMarkers(filteredObjects);
	    }
	}



	// checkbox change
  categoryCheckboxes.on('change', function() {
  	if ($(this).val() != 0){
  		block.find('input[value="0"]').prop('checked', false)
  	} else {
  		categoryCheckboxes.each(function(){
  			if ($(this).val() != 0) $(this).prop('checked', false);
  		})
  	}
    filterByCategory(getSelectedCategories)
  });


  function getSelectedCategories() {
    var selectedCategories = [];

    block.find('input[type="checkbox"]:checked').each(function() {
      selectedCategories.push($(this).val());
    });

    return selectedCategories;
  }


})



// 	// load map after google loaded scripts
// 	loader.load().then((google) => {

// 	    map = new google.maps.Map(block.find('.js-map')[0], {
// 	        center: { lat: 57.030165, lng: 24.422982 },
// 	        zoom: 7
// 	    });

// 	    addMarkers(locations);
// 	})

// 	function addMarkers(locations) {

// 	    locations.forEach(location => {
	    	
// 	        const marker = new google.maps.Marker({
// 	            position: location.location,
// 	            map: map,
// 	            title: '',
// 	            icon: location.icon,
// 	            categories: location.categories
// 	        });

// 	        markers.push(marker);

// 	        let infowindow = new google.maps.InfoWindow({
// 		        content: location.text
// 		      });

// 	        marker.addListener('click', function() {
// 		        infowindow.open(map, marker);
// 		      });
// 	    });

// 	    //console.log(markers)


// 	    // checkbox change
// 		  categoryCheckboxes.on('change', function() {
// 		  	if ($(this).val() != 0){
// 		  		block.find('input[value="0"]').prop('checked', false)
// 		  	} else {
// 		  		categoryCheckboxes.each(function(){
// 		  			if ($(this).val() != 0) $(this).prop('checked', false);
// 		  		})
// 		  	}
// 		    filterMarkers()
// 		  });

// 	}


// 	function filterMarkers() {
//     var selectedCategories = getSelectedCategories();

//     markers.forEach(function (marker) {
//       let isVisible = selectedCategories.some(function (category) {
//         return marker.categories.includes(parseInt(category));
//       });

//       marker.setVisible(isVisible);
//     });
//   }

//   function getSelectedCategories() {
//     var selectedCategories = [];

//     block.find('input[type="checkbox"]:checked').each(function() {
//       selectedCategories.push($(this).val());
//     });

//     return selectedCategories;
//   }




